import { Routes } from '@angular/router';

import { navPageResolver } from './cms';
import { NAVPAGE_ROUTE, SIDEBAR_ROUTE } from './shared';

export const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    {
        path: 'home',
        loadChildren: () => import('./home').then(m => m.routes)
    },
    {
        path: 'culture',
        loadChildren: () => import('./culture').then(m => m.routes)
    },
    {
        path: 'cafe',
        loadChildren: () => import('./cafe').then(m => m.routes)
    },
    {
        path: 'contact',
        loadChildren: () => import('./contact').then(m => m.routes)
    },
    {
        path: 'room',
        loadChildren: () => import('./room').then(m => m.routes)
    },
    {
        path: 'news',
        loadChildren: () => import('./news').then(m => m.routes)
    },
    {
        path: 'culturebus',
        loadChildren: () => import('./culturebus').then(m => m.routes)
    },
    {
        path: '**',
        data: {
            navPageKey: 'error'
        },
        resolve: {
            navPage: navPageResolver
        },
        children: [SIDEBAR_ROUTE, NAVPAGE_ROUTE]
    }
];
